"use client";

import { useEffect, useRef, useState } from "react";
import { VideoHero } from "./VideoHero";
import Letstalk from "./talkForm/talkWhy";
import LetstalkD from "./talkForm/talkDuble";

export default function Dubble() {
  const [isOpen, setIsOpen] = useState(false);
  const previewVideoRef = useRef<HTMLVideoElement>(null);
  const dialogVideoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  useEffect(() => {
    const preview = previewVideoRef.current;
    if (!preview) return;

    if (isOpen) {
      preview.pause();
    } else {
      preview.play().catch(() => {});
    }
  }, [isOpen]);

  useEffect(() => {
    const video = dialogVideoRef.current;
    if (!video) return;

    if (isOpen) {
      video.currentTime = 0;
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [isOpen]);

  return (
    <div className="rounded-b-3xl overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="bg-secondary p-4 lg:p-24">
          <h2 className="text-4xl lg:text-7xl text-primary font-extrabold uppercase pt-8 lg:pt-0 mb-8">
            Evinov Philosophy
          </h2>
          <div className="grid grid-cols-2 gap-4">
            <p className="max-w-prose text-sm lg:text-xl leading-relaxed font-light text-white text-neutral-600">
              At Evinov, we believe great websites are more than just
              beautiful interfaces, they are powerful digital solutions
              built to help businesses grow. Our mission is to combine
              thoughtful design, modern technology, performance, security,
              and functionality to create websites and web applications
              that deliver real value.
            </p>
            <p className="max-w-prose text-sm lg:text-xl leading-relaxed text-white font-light text-neutral-600">
              From business websites and ecommerce platforms to custom web
              applications, SEO, hosting, maintenance, and ongoing
              technical support, we provide everything needed to take a
              digital project from concept to a reliable, scalable online
              presence.
            </p>
            <p className="max-w-prose text-sm lg:text-xl leading-relaxed text-white font-light text-neutral-600">
              We work with modern technologies and a practical,
              results-driven approach, tailoring every solution to the
              unique goals and needs of each client. Whether you need a
              complete digital product or a specific development service,
              we focus on delivering clean, reliable, and future-ready
              solutions.
            </p>
            <p className="max-w-prose text-sm lg:text-xl leading-relaxed text-white font-light text-neutral-600">
              At Evinov, every project is treated with the same commitment
              to quality, professionalism, and attention to detail. We
              don&apos;t simply build websites, we build long-term digital
              foundations that businesses can rely on.
            </p>
          </div>
          <div className="flex justify-end">
            <Letstalk/>
          </div>
        </div>

        <div className="space-y-8 bg-primary p-4 lg:p-24">
          <h2 className="text-4xl lg:text-7xl text-white font-extrabold uppercase pt-8 lg:pt-0 mb-8">
            Our Partners
          </h2>

          <h3 className="text-2xl lg:text-4xl text-secondary font-bold">
            Building stronger digital solutions through trusted
            partnerships.
          </h3>
          <p className="max-w-prose lg:text-xl leading-relaxed text-white text-neutral-600">
            We collaborate with trusted technology providers, platforms,
            and digital services to bring the right tools and expertise to
            every project. These partnerships help us deliver reliable,
            secure, and scalable solutions while keeping our work aligned
            with modern industry standards.
          </p>
          <p className="max-w-prose lg:text-xl leading-relaxed text-white text-neutral-600">
            From cloud infrastructure and hosting to payment platforms,
            development tools, analytics, and other essential
            technologies, we carefully choose solutions that complement
            our services and support our clients&apos; goals.
          </p>

          <p className="max-w-prose lg:text-xl leading-relaxed text-white text-neutral-600">
            By combining technology, expertise, and strong collaboration,
            we create digital experiences that are built to perform today
            and grow with your business tomorrow.
          </p>

          <div className="flex justify-end">
          <LetstalkD/>
          </div>
        </div>
      </div>
    </div>
  );
}